// Copyright ©️ 2026 eVolve MEP, LLC

import {
  BendPreviewGeometry,
  type BendPreviewSpecifications,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';
import { convertToRadians } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/helpers';

export class OffsetGeometry extends BendPreviewGeometry {
  getDefaultDimensions() {
    // takeUpLength must exceed distanceToObstruction + (offsetHeight / tan(angle))
    return { ...super.getDefaultDimensions(), angle: 45, offsetHeight: 3, distanceToObstruction: 3, takeUpLength: 8 };
  }

  createBendDefs(dimensions: BendPreviewSpecifications) {
    const { angle, distanceToObstruction, offsetHeight, takeUpLength } = dimensions;
    const theta = convertToRadians(angle);
    const bendTriangleLegLength = offsetHeight / Math.tan(theta);

    const preBendLength = takeUpLength - distanceToObstruction - bendTriangleLegLength;
    const hypotenuse = offsetHeight / Math.sin(theta);

    return [
      {
        runLength: preBendLength,
        thenBendBy: theta,
        startLabels: [
          {
            label: 'Take Up Length',
            length: takeUpLength,
            offsets: [{ relativeTo: 'world', offset: 'down' }],
          },
        ],
        endLabels: [{ label: 'Angle', angle }],
      },
      {
        runLength: hypotenuse,
        thenBendBy: -theta,
      },
      {
        runLength: distanceToObstruction,
        endLabels: [
          {
            label: 'Distance to Obstruction',
            length: distanceToObstruction,
            offsets: [{ relativeTo: 'world', offset: 'down' }],
            isReverse: true,
          },
          {
            label: 'Offset Height',
            isVertical: true,
            length: offsetHeight,
            offsets: [{ relativeTo: 'world', offset: 'down' }],
          },
        ],
      },
    ] as const;
  }
}
